"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currencies_json_1 = __importDefault(require("@packages/data/currencies.json"));
const roundToCurrencyDecimals_1 = __importDefault(require("./roundToCurrencyDecimals"));
const formatCurrency = (value, options) => {
    const currencyCode = options.currencyCode || 'USD';
    const languageCode = options.languageCode || 'en';
    const countryCode = options.countryCode || 'US';
    try {
        const local = `${languageCode}-${countryCode}`;
        return new Intl.NumberFormat(local, { style: 'currency', currency: currencyCode }).format(value);
    }
    catch (error) {
        try {
            return new Intl.NumberFormat(languageCode, { style: 'currency', currency: currencyCode }).format(value);
        }
        catch (error) {
            const currency = currencies_json_1.default[currencyCode];
            if (!currency)
                return `${currencyCode}${value.toFixed(2)}`;
            return `${currency.symbol}${value.toFixed(currency.decimals)}`;
        }
    }
};
const toFormattedString = (value, options = {}) => {
    const formattedCurrency = options.applyCurrencyFormatting === true || options.applyCurrencyFormatting == null
        ? formatCurrency(value, options)
        : (0, roundToCurrencyDecimals_1.default)(value, options.currencyCode);
    return options.includeSign && value >= 0 ? `+${formattedCurrency}` : formattedCurrency;
};
exports.default = toFormattedString;
